const educationData = [
	{
		schoolName: 'Quantic',
		schoolLogo: 'kjhjkh',
		schoolWebsiteURL: 'jhghjgj',
		degreeType: '',
		programDetails: '',
		accomplishments: [
			'graduated with honors',
			'4.0 gpa'
		]
	},
	{
		schoolName: 'kjjkhjk',
		schoolLogo: 'kjhjkh',
		schoolWebsiteURL: 'jhghjgj',
		degreeType: '',
		programDetails: '',
		accomplishments: [
			'graduated with honors',
			'4.0 gpa'
		]
	},
	{
		schoolName: 'kjjkhjk',
		schoolLogo: 'kjhjkh',
		schoolWebsiteURL: 'jhghjgj',
		degreeType: '',
		programDetails: '',
		accomplishments: [
			'graduated with honors',
			'4.0 gpa'
		]
	}
];

export default educationData;
